import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import AppLoader from "../component/AppLoader";
import Actions from "../Redux/action";
import { hostelDashboardData } from "../Redux/reducer/HostelDashboardReducer";

const CLICKABLE_STATUSES = ["Total Present", "Total Absent", "Present But Not Appeared", "Present But Not Appeared "];

const TERM_DESCRIPTIONS = {
    "Total Students": "Total number of active students enrolled in this hostel.",
    "Total Present": "Students currently inside the hostel who have been detected today (appeared for attendance).",
    "Total Absent": "Students who have exited the hostel and are currently outside.",
    "Present But Not Appeared": "Students inside the hostel who entered before today but not yet appeared in today's attendance.",
    "Special Access": "Students granted special access permissions to enter or exit the hostel outside regular hours.",
};

export const HostelDashBoard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [hostelDashboard, setHostelDashboard] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const data = useSelector(hostelDashboardData);

    const handleBlockClick = useCallback((hostelId, status, hostelName, period) => {
        if (!CLICKABLE_STATUSES.includes(status?.trim()) || !hostelId) return;
        navigate("/dashboard/details", {
            state: { hostelId, status: status.trim(), hostelName, period },
        });
    }, [navigate]);

    const fetchData = useCallback(() => {
        const callback = (response) => {
            if (response?.status_code === 0) {
                setHostelDashboard(response?.response);
            } else {
                toast.error("Something went wrong");
            }
            setLoading(false);
        };

        setLoading(true);
        dispatch(Actions.hostelDashboardAction('', callback));
    }, [dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const renderHostelData = (title, data, period) => (
        <div>
            <div className="row">
                <div className="col-12">
                    <h3 className="pageheader-title pageheader-spacing">{title}</h3>
                </div>
            </div>
            {Array.isArray(data) && data.map((hostel, index) => (
                <div key={index}>
                    <div className="row">
                        <div className="col-12">
                            <h4 className="pageheader-title">{hostel?.name}</h4>
                        </div>
                    </div>
                    <div className="row">
                        {hostel?.data && hostel.data.map((entry, i) => (
                            Object.keys(entry).map((key, j) => {
                                const isClickable = CLICKABLE_STATUSES.includes(key?.trim()) && hostel?.hostel_id && entry[key] > 0;
                                return (
                                    <div className="dashboard-card-align" key={j}>
                                        <div
                                            className={`card card-hostel-dashboard border-3 border-top border-top-primary position-relative ${isClickable ? 'cursor-pointer' : ''}`}
                                            onClick={() => isClickable && handleBlockClick(hostel.hostel_id, key, hostel.name, period)}
                                            style={isClickable ? { cursor: 'pointer' } : {}}
                                        >
                                            <i
                                                className="fas fa-info-circle text-muted position-absolute"
                                                style={{ top: '0.5rem', right: '0.5rem', fontSize: '0.85rem', cursor: 'help', zIndex: 1 }}
                                                data-tooltip-id="dashboard-term-tooltip"
                                                data-tooltip-content={TERM_DESCRIPTIONS[key?.trim()] || 'No description available'}
                                                onClick={(e) => e.stopPropagation()}
                                            ></i>
                                            <div className="card-body dashboardCards">
                                                <h4 className="text-muted bold card-text-muted">{key}</h4>
                                                <h5 className="text-muted">{entry[key]}</h5>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <>
            <Tooltip id="dashboard-term-tooltip" place="top" positionStrategy="fixed" style={{ zIndex: 9999 }} />
            {isLoading && <AppLoader />}
            <div className="ecommerce-widget">
                <div className="page-header">
                    <div className="row">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                            <h2 className="pageheader-title">Dashboard</h2>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={fetchData}
                                disabled={isLoading}
                            >
                                <i className="fas fa-sync-alt me-2"></i>
                                Refresh
                            </button>
                        </div>
                    </div>
                </div>
                {hostelDashboard?.today && renderHostelData("Today", hostelDashboard.today, "today")}
                {hostelDashboard?.yesterday && renderHostelData("Yesterday", hostelDashboard.yesterday, "yesterday")}
            </div>
        </>
    );
};
